module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column align-items-center"
  }, [_c('h1', {
    staticClass: "main-title display-4"
  }, [_vm._v("Young Forever")]), _vm._v(" "), _c('h2', {
    staticClass: "main-title"
  }, [_vm._v("Katarzyna Bieńkowska")]), _vm._v(" "), _c('hr', {
    staticClass: "separator"
  }), _vm._v(" "), _c('h3', {
    staticClass: "secondary-title"
  }, [_vm._v("mobilny gabinet kosmetyczny")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-523478c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/landing/components/SectionLeft.vue
// module id = 47
// module chunks = 0